// extracted by mini-css-extract-plugin
module.exports =  {"image":"QHl0ZB"};